import { render, staticRenderFns } from "./VgBadNeustadtEntranceMonitor.vue?vue&type=template&id=675cc315&scoped=true&"
import script from "./VgBadNeustadtEntranceMonitor.vue?vue&type=script&lang=js&"
export * from "./VgBadNeustadtEntranceMonitor.vue?vue&type=script&lang=js&"
import style0 from "./VgBadNeustadtEntranceMonitor.vue?vue&type=style&index=0&id=675cc315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675cc315",
  null
  
)

export default component.exports